// @flow
import { defineMessages } from 'react-intl'

// Constants
import {
  ATTR_LAST,
  ATTR_FIRST,
  ATTR_USERNAME,
  ATTR_PHONE,
  ATTR_EMAIL,
} from './constants'

export default defineMessages({
  [ATTR_LAST]: {
    id: 'fcUsers.dataTable.last',
    defaultMessage: 'Last',
  },
  [ATTR_FIRST]: {
    id: 'fcUsers.dataTable.first',
    defaultMessage: 'First',
  },
  [ATTR_USERNAME]: {
    id: 'fcUsers.dataTable.username',
    defaultMessage: 'Username',
  },
  [ATTR_PHONE]: {
    id: 'fcUsers.dataTable.phone',
    defaultMessage: 'Phone',
  },
  [ATTR_EMAIL]: {
    id: 'fcUsers.dataTable.email',
    defaultMessage: 'Email',
  },
})
